// Stats page — game statistics
import { getGameStats, getPuzzleStats } from '../../stats/store';
import { getCurrentLevel } from '../../stats/level';
import { getUnlockedAchievements, ACHIEVEMENTS } from '../../stats/achievements';

export async function renderStats(): Promise<string> {
  const gameStats = await getGameStats();
  const puzzleStats = await getPuzzleStats();
  const { level, points, nextLevel } = await getCurrentLevel();
  const unlocked = await getUnlockedAchievements();

  const progressToNext = nextLevel
    ? Math.round(((points - level.minPoints) / (nextLevel.minPoints - level.minPoints)) * 100)
    : 100;

  return `
    <div class="stats-page">
      <h1 class="page-title">📊 Statistik</h1>

      <!-- Level Card -->
      <div class="card level-card mb-lg">
        <div class="level-icon">${level.icon}</div>
        <div class="level-info">
          <div class="level-name">${level.name}</div>
          <div class="level-points">${points} poin</div>
          ${nextLevel ? `
            <div class="level-progress">
              <div class="progress-bar">
                <div class="progress-fill" style="width:${progressToNext}%"></div>
              </div>
              <span class="text-secondary">${nextLevel.minPoints - points} poin lagi ke ${nextLevel.name}</span>
            </div>
          ` : '<div class="text-secondary">Level maksimal! 👑</div>'}
        </div>
      </div>

      <!-- Game Stats -->
      <h2 class="section-title">🎮 Permainan</h2>
      <div class="grid-2 mb-lg">
        <div class="stat-card card">
          <div class="stat-value">${gameStats.total}</div>
          <div class="stat-label">Total Permainan</div>
        </div>
        <div class="stat-card card">
          <div class="stat-value">${gameStats.winRate}%</div>
          <div class="stat-label">Win Rate</div>
        </div>
        <div class="stat-card card win">
          <div class="stat-value">${gameStats.wins}</div>
          <div class="stat-label">Menang</div>
        </div>
        <div class="stat-card card loss">
          <div class="stat-value">${gameStats.losses}</div>
          <div class="stat-label">Kalah</div>
        </div>
        <div class="stat-card card draw">
          <div class="stat-value">${gameStats.draws}</div>
          <div class="stat-label">Seri</div>
        </div>
      </div>

      <!-- Puzzle Stats -->
      <h2 class="section-title">🧩 Puzzle</h2>
      <div class="grid-2 mb-lg">
        <div class="stat-card card">
          <div class="stat-value">${puzzleStats.solved}</div>
          <div class="stat-label">Puzzle Selesai</div>
        </div>
        <div class="stat-card card">
          <div class="stat-value">${puzzleStats.total}</div>
          <div class="stat-label">Total Dicoba</div>
        </div>
      </div>

      <!-- Achievements -->
      <h2 class="section-title">🏆 Achievements</h2>
      <div class="achievements-grid">
        ${ACHIEVEMENTS.map(a => {
          const isUnlocked = unlocked.includes(a.id);
          return `
            <div class="achievement-card card ${isUnlocked ? 'unlocked' : 'locked'}">
              <div class="achievement-icon">${isUnlocked ? a.icon : '🔒'}</div>
              <div class="achievement-name">${a.name}</div>
              <div class="achievement-desc">${a.description}</div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

export function initStats(): void {
  // No interactive elements on stats page currently
}
